import React, { useState } from "react";
import { Card, CardBody, Button } from "reactstrap";
import PropTypes from "prop-types";
import { useLoginMutation } from "../../../services/auth/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import ToastNotification from "components/Toast/ToastNotification";
import slash from "assets/icons/slash-circle.svg";

const LoginResult = ({ userData }) => {
  const [login] = useLoginMutation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async () => {
    if (!userData?.email || !userData?.password) {
      navigate("/auth/login");
      return;
    }

    try {
      setIsLoggingIn(true);
      await login({
        email: userData.email,
        password: userData.password,
      });

      // Get redirect URL from query params or use default
      const redirectTo = searchParams.get("redirect");
      const redirectPath = redirectTo ? decodeURIComponent(redirectTo) : "/";

      // Navigate to the intended page
      navigate(redirectPath);
    } catch (error) {
      let id = toast.custom(
        <ToastNotification variant="danger" icon={slash} title="เข้าสู่ระบบไม่สำเร็จ" description="เกิดข้อผิดพลาดในการเข้าสู่ระบบ" onSecondaryClick={() => toast.dismiss(id)} />,
        { position: "top-right", duration: 5000 }
      );
      navigate("/auth/login");
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <Card className="card-auth">
      <CardBody className="text-center">
        <div className="mb-6">
          <div className="text-success mb-5">
            <i className="ri-checkbox-circle-line display-4" />
          </div>
          <h1 className="text-2xl font-bold mb-2">ยืนยันตัวตนสำเร็จ</h1>
          <h3 className="text-gray-600">ขอบคุณที่ยืนยันตัวตนกับเรา</h3>
        </div>

        <Button color="primary" size="lg" className="w-100" onClick={handleLogin} disabled={isLoggingIn}>
          {isLoggingIn ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" />
              กำลังเข้าสู่ระบบ...
            </>
          ) : (
            "เข้าสู่หน้าหลัก"
          )}
        </Button>
      </CardBody>
    </Card>
  );
};

LoginResult.propTypes = {
  userData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
  }).isRequired,
};

export default LoginResult;
